export const isMaterialNumberValid = (string_) => {
  if (!string_) {
    return false
  }
  return string_.length === 11 && /^\d\.\d{3}-\d{3}\.\d/.test(string_)
}

export const formatMaterialID = (string_, digits = 8) => {
  const lastDigits = +(digits - 7)
  const regexString = `^([0-9]{1})([0-9]{3})([0-9]{3})([0-9]{${lastDigits}})`

  const result = [...string_.matchAll(new RegExp(regexString, 'g'))][0]

  if (!result) {
    return string_
  }

  return `${result[1]}.${result[2]}-${result[3]}.${result[4]}`
}
